// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_JgQ","cls2":"AuthorHeader-cls2_NSC AuthorHeader-cls1_JgQ"};